/**
 * @GENERATED from Figma node 3638:52263
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const IllustratorDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#FF8E21"
      d="m9.29 8.674.159-.888.16.888 2.231 6.378H7.125zm4.714 12.551h3.03l-6.036-16.24H7.9L2 21.224h3.052l1.23-3.644h6.447zM20.018 6.715c1.321 0 1.982-.57 1.982-1.981 0-1.458-.683-1.96-1.982-1.96s-1.982.502-1.982 1.96c0 1.48.547 1.981 1.982 1.981m1.48 14.51V8.128H18.47v13.097z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(IllustratorDark);
export { ForwardRef as IllustratorDark };
